import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Pencil, Trash2 } from "lucide-react";
import { Header, EditModal, Grid2, Input } from "./AdminSimulators";

const CATS = ["Corrida", "F1", "Avião", "Montanha Russa", "Eventos"];
const SPANS = ["normal", "tall", "wide"];
const empty = { title: "", category: "Eventos", image_url: "", span: "normal", order: 0, active: true };

export default function AdminGallery() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = async () => setItems((await api.get("/admin/gallery")).data);
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing.id) await api.put(`/admin/gallery/${editing.id}`, editing);
      else await api.post("/admin/gallery", editing);
      toast.success("Salvo");
      setEditing(null);
      load();
    } catch (e) { toast.error("Erro"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Excluir?")) return;
    await api.delete(`/admin/gallery/${id}`);
    load();
  };

  return (
    <div data-testid="admin-gallery">
      <Header title="Galeria" onCreate={() => setEditing({ ...empty })} />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {items.map((g) => (
          <div key={g.id} className="relative rounded-xl overflow-hidden border border-white/5 group aspect-square">
            <img src={g.image_url} alt={g.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 flex flex-col justify-between p-4 transition-opacity">
              <div>
                <div className="text-xs uppercase tracking-widest text-neutral-400">{g.category}</div>
                <div className="text-sm text-white">{g.title}</div>
              </div>
              <div className="flex gap-2">
                <button onClick={() => setEditing(g)} className="flex-1 rounded-lg bg-white/10 py-2 text-xs"><Pencil className="w-3 h-3 inline" /></button>
                <button onClick={() => remove(g.id)} className="rounded-lg bg-[#E31B23]/70 px-3 py-2 text-xs"><Trash2 className="w-3 h-3" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <EditModal onClose={() => setEditing(null)} onSave={save} title={editing.id ? "Editar item" : "Novo item"}>
          <Input label="Título" v={editing.title} on={(v) => setEditing({ ...editing, title: v })} />
          <Input label="URL da imagem*" v={editing.image_url} on={(v) => setEditing({ ...editing, image_url: v })} />
          <Grid2>
            <div>
              <label className="block overline text-neutral-400 mb-2">Categoria</label>
              <select value={editing.category} onChange={(e) => setEditing({ ...editing, category: e.target.value })} className="w-full bg-[#111] border border-white/10 rounded-lg px-4 py-3">
                {CATS.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label className="block overline text-neutral-400 mb-2">Tamanho</label>
              <select value={editing.span} onChange={(e) => setEditing({ ...editing, span: e.target.value })} className="w-full bg-[#111] border border-white/10 rounded-lg px-4 py-3">
                {SPANS.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
          </Grid2>
          <Grid2>
            <Input label="Ordem" type="number" v={editing.order} on={(v) => setEditing({ ...editing, order: Number(v) })} />
            <label className="flex items-center gap-2 mt-8"><input type="checkbox" checked={editing.active} onChange={(e) => setEditing({ ...editing, active: e.target.checked })} /> Ativo</label>
          </Grid2>
        </EditModal>
      )}
    </div>
  );
}
